import React, { useState } from "react";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import Stack from "@vapor/react-material/Stack";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import ExtendedTabs from "@vapor/react-extended/ExtendedTabs";
import ExtendedTab from "@vapor/react-extended/ExtendedTab";
import { DataGridPro, GridToolbar, itIT } from "@mui/x-data-grid-pro";
import { NoData } from "../../../components/NoData";

export const DashboardFascicoli = ({
  fascicoliIncompleteList,
  fascicoliIncompleteColumns,
  fascicoliCompleteList,
  fascicoliCompleteColumns,
  onGoToFascicolo,
}) => {
  const [selectedIncompleteTab, setSelectedIncompleteTab] = useState("tabIncomplete");

  const handleChangeIncompleteTab = (event, newValue) => {
    setSelectedIncompleteTab(newValue);
  };

  return (
    <Card sx={{ width: "50%", minWidth: 0 }}>
      <CardContent sx={{ p: { xs: 2, md: 4 } }}>
        <Stack direction="column" spacing={1}>
          <ExtendedTypography variant="titleSmall" color="primary.main" gutterBottom>
            Fascicoli
          </ExtendedTypography>

          <ExtendedTabs
            variant="standard"
            size="small"
            value={selectedIncompleteTab}
            onChange={handleChangeIncompleteTab}
            sx={{ mb: 2 }}
          >
            <ExtendedTab value="tabIncomplete" label="Incompleti" />
            <ExtendedTab value="tabComplete" label="Completi" />
          </ExtendedTabs>

          {selectedIncompleteTab === "tabIncomplete" && (
            <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
              {fascicoliIncompleteList.length > 0 ? (
                <DataGridPro
                  rows={fascicoliIncompleteList}
                  columns={fascicoliIncompleteColumns}
                  slots={{ toolbar: GridToolbar }}
                  autoHeight={true}
                  pageSizeOptions={[5, 10, 15]}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  pagination
                  disableRowSelectionOnClick
                  onRowClick={(item, e) => onGoToFascicolo(e, item.row)}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              ) : (
                <NoData size="small" />
              )}
            </Stack>
          )}

          {selectedIncompleteTab === "tabComplete" && (
            <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
              {fascicoliCompleteList.length > 0 ? (
                <DataGridPro
                  rows={fascicoliCompleteList}
                  columns={fascicoliCompleteColumns}
                  slots={{ toolbar: GridToolbar }}
                  autoHeight={true}
                  pageSizeOptions={[5, 10, 15]}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  pagination
                  disableRowSelectionOnClick
                  onRowClick={(item, e) => onGoToFascicolo(e, item.row)}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              ) : (
                <NoData size="small" />
              )}
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
